import React from "react";
import Blok from "../../../interfaces/Storyblok/Blok.interface";
import Crumb from "../../atoms/Crumb/Crumb.atom";
import ContactCard, { ContactCardProps } from "./ContactCard.blok";

interface ContactCardSectionProps extends Blok {
  crumb?: string;
  title?: string;
  description?: string;
  contact_cards?: ContactCardProps[];
  id?: string;
}

const ContactCardSection: React.FC<ContactCardSectionProps> = ({
  id,
  crumb,
  title,
  description,
  contact_cards = [],
}) => {
  return (
    <div id={id} className="bg-Primary-50">
      <div className="container mx-auto py-12 md:py-16 lg:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[minmax(0,412px)_1fr] lg:gap-16 xl:grid-cols-[minmax(0,1fr)_auto]">
          {/*-- header --*/}
          <div className="flex flex-col">
            {crumb && <Crumb label={crumb} className="mb-4" />}
            {title && <h2 className="text-3xl font-extrabold leading-tight text-Primary-900 md:text-4xl">{title}</h2>}
            {description && <p className="mt-6 text-base font-semibold text-Primary-700 lg:text-lg">{description}</p>}
          </div>

          {/*-- cards --*/}
          {!!contact_cards.length && (
            <ul className="grid grid-cols-1 gap-6 sm:grid-cols-2">
              {contact_cards.map((card: ContactCardProps, index: number) => (
                <ContactCard key={card._uid ?? `contact-card--${index + 1}`} {...card} />
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactCardSection;
